export const canEditMarker = (user, marker) => {
    if (!user || !marker) return false;
    const isPrivileged = ["admin", "teacher"].includes(user.role);
    return isPrivileged || user.login_id === marker.creatorId;
};

export const canShowDetails = (user) => {
    if (!user) return false;
    const isPrivileged = ["admin", "teacher"].includes(user.role);
    return isPrivileged
};